export default {
  SET_PENDING(state, pending) {
    state.pending = pending || [];
  },
  SET_PENDING_PAGINATION(state, pagination) {
    state.pendingPagination = {
      totalPages: pagination && pagination.totalPages ? pagination.totalPages : 0,
      totalItems: pagination && pagination.totalItems ? pagination.totalItems : 0
    };
  },
  SET_REQUESTS(state, requests) {
    state.requests = requests || [];
  },
  SET_REQUESTS_PAGINATION(state, pagination) {
    state.requestsPagination = {
      totalPages: pagination && pagination.totalPages ? pagination.totalPages : 0,
      totalItems: pagination && pagination.totalItems ? pagination.totalItems : 0
    };
  },
  SET_CURRENT_REQUEST(state, request) {
    state.currentRequest = request;
  },
  SET_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications || [];
    state.unreadCount = state.notifications.filter(item => !item.is_read).length;
  },
  SET_LOADING(state, status) {
    state.loading = status;
  }
}
